import { expVal } from '@atlassian/jira-feature-experiments';

const JiraDevPanelAiDevexExperimentRelayProvider = {
	get(): boolean {
		return expVal('jira_dev_panel_ai_devex', 'isEnabled', false);
	},
};

export default JiraDevPanelAiDevexExperimentRelayProvider;
